import styled from 'styled-components';

interface ButtonProps {
  title: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset'; // type 속성을 선택적으로 추가
  fiexd?: boolean;
}

export const Button = ({
  title,
  onClick,
  fiexd = false,
  type = 'button',
}: ButtonProps) => {
  return (
    <BtnBox $fixed={fiexd}>
      <button onClick={onClick} type={type}>
        {title}
      </button>
    </BtnBox>
  );
};

//styled
const BtnBox = styled.div<{ $fixed: boolean }>`
  position: ${({ $fixed }) => ($fixed ? 'fixed' : 'static')};
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $fixed }) => ($fixed ? '2rem 2rem 3.2rem' : '1.2rem 0 0.8rem')};
  background-color: ${(props) => props.theme.textWhiteColor};
  button {
    width: 100%;
    background-color: ${(props) => props.theme.btnBlueColor};
    color: ${(props) => props.theme.textWhiteColor};
    padding: 1.7rem;
    border-radius: 1.2rem;
    border: 0;
    outline: none;
    font-size: 1.8rem;
    font-weight: 600;
    &:active {
      transform: scale(0.98);
    }
  }
`;
